export default function PageNotFound() {
  return <div>page-not-found</div>;
}
